// import external dependencies
import 'jquery';
import 'select2';
import 'slick-carousel';
import '@fancyapps/fancybox';
import 'imagesloaded/imagesloaded.pkgd.js';
import 'isotope-layout/dist/isotope.pkgd.js';
import 'isotope-packery/packery-mode.pkgd.js';

// Import everything from autoload
import './autoload/_bootstrap.js'

// import local dependencies
import Router from './util/Router';
import common from './routes/common';
import home from './routes/home';
// import about from './routes/about';
import single from './routes/single';

/** Populate Router instance with DOM routes */
const routes = new Router({
  // All pages
  common,
  // Home page
  home,
  // About Us page, note the change from about-us to aboutUs.
  // about,
  single,
});

// Load Events
jQuery(document).ready(() => routes.loadEvents());

// import Turbolinks from 'turbolinks';
// Turbolinks.start();



// WEBPACK FOOTER //
// ./scripts/main.js